import urls from '../api_urls/videoManagement'
import { _post } from '@/axios/request'

// 获取video列表
export function getVideoData (params) {
  return _post(urls.GET_VIDEO_LIST, params)
}

// 获取segment
export function getSegment () {
  return _post(urls.GET_SEGMENT_LIST, { pid: 2 })
}

// 保存video信息
export function saveVideo (params) {
  return _post(urls.SAVE_VIDEO, params)
}

// 获取video信息
export function getDetail (params) {
  return _post(urls.GET_VIDEO_DETAIL, params)
}

// 更新video信息
export function updateDetail (params) {
  return _post(urls.UPDATE_DETAIL, params)
}

// 更新video状态
export function updateStatus (params) {
  return _post(urls.UPDATE_STATUS, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/videoManagement.js